import {inject, Injectable} from '@angular/core';

import {DocumentMetadataDTO} from '@dto/documents/document-metadata.dto';
import {DocumentViewModel} from '../models/document.view-model';
import {DateFormatterService} from '@shared/services/date-formatter.service';
import {DateConverterService} from '@shared/services/date-converter.service';
import {Utils} from '@shared/utilities/utils';

@Injectable({
  providedIn: 'root'
})
export class DocumentConverterService {
  private readonly dateConverterService = inject(DateConverterService);
  private readonly dateFormatterService = inject(DateFormatterService);

  convert(documents: DocumentMetadataDTO[]): DocumentViewModel[] {
    return documents.map(c => this.convertSingle(c));
  }

  private convertSingle(document: DocumentMetadataDTO): DocumentViewModel {

    const formattedFileExtension = Utils.getFormattedFileExtension(document.fileExtension);
    const formattedFileExtensionLowerCase = formattedFileExtension.toLowerCase();
    let fileDownloadName: string;

    if (formattedFileExtension.length > 0) {
      fileDownloadName = document.fileName + '.' + formattedFileExtension;
    } else {
      fileDownloadName = document.fileName;
    }

    const uploadedDateTime = document.uploadedDateTime ? this.dateConverterService.toDate(document.uploadedDateTime) : null;

    const iconUrl = Utils.getFileIconSource(formattedFileExtensionLowerCase);
    const isGenericIcon = Utils.getFileIconIsGeneric(formattedFileExtensionLowerCase);

    return {
      clientCode: document.clientCode,
      entryNo: document.entryNo,
      documentTitle: document.documentTitle,
      fileExtension: formattedFileExtensionLowerCase,
      fileDownloadName: fileDownloadName,
      clientName: document.clientName,
      downloadButtonText: 'Download',
      downloadButtonLabel: 'Download ' + document.clientName + ' ' + fileDownloadName,
      uploadedDateTime: uploadedDateTime,
      uploadedDateTimeString: this.dateFormatterService.formatDateTime(uploadedDateTime),
      iconUrl,
      isGenericIcon
    };
  }
}
